module.exports = __webpack_public_path__ + "media/email-unsubscribe/resub-success-c3c4582f.png";